import { useState, useEffect } from 'react';
import vapiVariableService from '../services/vapiVariableService';
import api from '../api';

export const useVapiVariables = (type = null,user_id = null) => {
    const [variables, setVariables] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [userTimezone, setUserTimezone] = useState('America/Phoenix');

    const fetchVariables = async () => {
        try {
            setLoading(true);
            setError(null);
            
            let response;
            let params = {};
            if (type) {
                params = {type,user_id};

            }
            api.botbuilder.getVapiVariables(params).then((response) => {
                if (response.status) {
                    setVariables(response.data || []);
                    setUserTimezone(response.user_timezone || 'America/Phoenix');
                } else {
                    throw new Error(response.message || 'Failed to fetch variables');
                }
            });

            
        } catch (err) {
            console.error('Error fetching variables:', err);
            setError(err.message);
            
            // Use fallback variables in case of API error
            const fallbackVariables = vapiVariableService.getFallbackVariables();
            setVariables(fallbackVariables);
        } finally {
            setLoading(false);
        }
    };

    const refreshVariables = () => {
        fetchVariables();
    };

    const getVariableByKey = (key) => {
        return variables.find(variable => variable.key === key || variable.value === key);
    };

    const getVariablesByType = (variableType) => {
        return variables.filter(variable => variable.type === variableType);
    };

    useEffect(() => {
        fetchVariables();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type]);

    return {
        variables,
        loading,
        error,
        refreshVariables,
        getVariableByKey,
        getVariablesByType,
        userTimezone
    };
};
